import {observer} from 'mobx-react';
import React from 'react';

import {TrackerInitializer} from '@udemy/event-tracking';
import {Footer} from '@udemy/footer';
import {Header, SearchBarMXEnum} from '@udemy/react-header';
import {Toaster} from '@udemy/react-messaging-components';
import {useStores} from '@udemy/store-provider';

// TODO: decouple smartbar from header
// import {SmartBar} from '@udemy/smart-bar';
import {RootStore} from 'src/stores/root-store';

import styles from './layout.module.less';

export const getLayout = (page: React.ReactElement) => {
    return <Layout>{page}</Layout>;
};

const Layout = observer(({children}: {children: React.ReactElement}) => {
    const [rootStore] = useStores([RootStore]);
    /**
     * This is for mobile webview renders. Normally we shouldn't be going to here but this is a legacy support from
     * django that integrated all over our apps so we need to support it.
     */
    const shouldRenderHeaderAndFooter = () => {
        if (typeof window !== 'undefined') {
            const displayTypeParam = new URLSearchParams(window.location.search).get(
                'display_type',
            );
            return displayTypeParam !== 'mobile_app';
        }
        return true;
    };
    return (
        <>
            {/*<SmartBar /> */}
            <div className={styles['container']}>
                {shouldRenderHeaderAndFooter() && (
                    <Header
                        {...rootStore.headerData}
                        showTwoRowSearchBarMX={SearchBarMXEnum.OldBar}
                    />
                )}
                <main className={styles['content']}>{children}</main>
                {shouldRenderHeaderAndFooter() && (
                    <Footer clientProps={rootStore.footerData} serverProps={rootStore.footerData} />
                )}
                <Toaster />
            </div>
            <TrackerInitializer />
        </>
    );
});
